import { render, staticRenderFns } from "./category-leaflet.vue?vue&type=template&id=2353c934&"
import script from "./category-leaflet.vue?vue&type=script&lang=js&"
export * from "./category-leaflet.vue?vue&type=script&lang=js&"
import style0 from "./category-leaflet.vue?vue&type=style&index=0&id=2353c934&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports